module.exports = __webpack_public_path__ + "img/pizzeria-closed.6a7ed2a4.png";